import { render, staticRenderFns } from "./AdminPayerDetail.vue?vue&type=template&id=15a23178&scoped=true"
import script from "./AdminPayerDetail.vue?vue&type=script&lang=js"
export * from "./AdminPayerDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminPayerDetail.vue?vue&type=style&index=0&id=15a23178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a23178",
  null
  
)

export default component.exports